import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Dialog,
  Form,
  FormItem,
  Select,
  Switch,
  Radio,
  RadioGroup,
  Tabs,
  TabPane,
  Option,
  Input,
  Message,
  MessageBox
} from 'element-ui';

function importVue (Vue) {
  // Vue.use(MessageBox);
  Vue.use(Button);
  Vue.use(Dropdown);
  Vue.use(DropdownItem);
  Vue.use(DropdownMenu);
  Vue.use(Dialog);
  Vue.use(Form);
  Vue.use(FormItem);
  Vue.use(Select);
  Vue.use(Switch);
  Vue.use(Radio);
  Vue.use(RadioGroup);
  Vue.use(Tabs);
  Vue.use(TabPane);
  Vue.use(Option);
  Vue.use(Input);

  Vue.prototype.$message = Message;
  Vue.prototype.$confirm = MessageBox.confirm;
}

export default importVue;
